import { Checkbox, DataSource, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierPayDetail extends Layout {
    checkboxExcludeOrderType: Checkbox;
    checkboxIncludePartialMovements: Checkbox;
    labelAdded: Label;
    labelDividendMargin: Label;
    labelDividendNotMargin: Label;
    labelDivisorMargin: Label;
    labelDivisorNotMargin: Label;
    labelLeftParenMargin: Label;
    labelLeftParenNotMargin: Label;
    labelRightParenMargin: Label;
    labelRightParenNotMargin: Label;
    labelScoreDetailMargin2: Label;
    labelScoreDetailMargin3: Label;
    labelScoreDetailMargin: Label;
    labelScoreDetailsNotMargin2: Label;
    labelScoreDetailsNotMargin3: Label;
    labelScoreDetailsNotMargin: Label;
    labelSubtracted: Label;
    labelWeightMargin: Label;
    labelWeightNotMargin: Label;
    panelFormulaMargin: Panel;
    panelFormulaNotMargin: Panel;
    panelMargin: Panel;
    panelMarginDetail: Panel;
    panelNotMarginDetail: Panel;
    sourceCarrierScorecardDetail: DataSource;
    tabScoringDetails: Tab;
    tabsetScoringDetails: Tabset;
    textboxComparison: Textbox;
    textboxComparisonValue: Textbox;
    textboxEndOfPeriod: Textbox;
    textboxMeasure: Textbox;
    textboxMinimumRecords: Textbox;
    textboxOrderTypes: Textbox;
    textboxPayToCompare: Textbox;
    textboxStartOfPeriod: Textbox;
    textboxWeight: Textbox;
}
